import React from 'react';
import PropTypes from 'prop-types';
import ProspectBreakdownChart from './ProspectBreakdownChart';
import ConnectedProspectPercentage from './ConnectedProspectPercentage';
import CallTypeBreakdown from './CallTypeBreakdown';
import LocationCallTypeTable from './LocationCallTypeTable';
import SourceBreakdownTable from './SourceBreakdownTable';
import ErrorBoundary from '../reporting_utils/ErrorBoundary';
import { BadgeList, Badge } from '../reporting_utils/Badge';

function ScheduledProspectReport({ reportData, domainSettings, groupNames, locationNames }) {
  const {
    ad_source_breakdown,
    call_type_breakdown,
    call_type_percentages,
    prospect_breakdown,
    prospect_connected,
  } = reportData;

  const { isAutomotiveIndustry, prospectCallTypes, industryType } = domainSettings;

  return (
    <div className='report-details-container'>
      <div className='report-details-header'>
        <div className='report-details-title'>
          <h1>{isAutomotiveIndustry ? 'Prospect Connectivity' : 'Lead Connectivity'}</h1>
        </div>
      </div>
      <div>
        {groupNames.length > 0 ? (
          <BadgeList title='Selected groups' maxLength={3}>
            {groupNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
        {locationNames.length > 0 ? (
          <BadgeList title='Selected locations' maxLength={3}>
            {locationNames.map((name) => (
              <Badge label={name} key={name} />
            ))}
          </BadgeList>
        ) : null}
      </div>
      <ErrorBoundary>
        <div className='row'>
          <div className={isAutomotiveIndustry ? 'col-xs-12 col-md-4' : 'col-xs-12 col-sm-6'}>
            <ProspectBreakdownChart
              isAutomotiveIndustry={isAutomotiveIndustry}
              chartData={prospect_breakdown}
              industryType={industryType}
            />
          </div>
          {isAutomotiveIndustry && (
            <div className='col-xs-12 col-md-4'>
              <ConnectedProspectPercentage chartData={prospect_connected} />
            </div>
          )}
          <div className={isAutomotiveIndustry ? 'col-xs-12 col-md-4' : 'col-xs-12 col-sm-6'}>
            <CallTypeBreakdown
              chartData={call_type_percentages}
              isAutomotiveIndustry={isAutomotiveIndustry}
            />
          </div>
        </div>
        <LocationCallTypeTable
          isAutomotiveIndustry={isAutomotiveIndustry}
          tableData={call_type_breakdown}
        />
        <SourceBreakdownTable
          isAutomotiveIndustry={isAutomotiveIndustry}
          tableData={ad_source_breakdown}
          prospectCallTypes={prospectCallTypes}
          industryType={industryType}
        />
      </ErrorBoundary>
    </div>
  );
}

ScheduledProspectReport.propTypes = {
  reportData: PropTypes.shape({
    ad_source_breakdown: PropTypes.array.isRequired,
    call_type_breakdown: PropTypes.array.isRequired,
    call_type_percentages: PropTypes.array.isRequired,
    prospect_breakdown: PropTypes.array.isRequired,
    prospect_connected: PropTypes.arrayOf(
      PropTypes.exact({ connected_percentage: PropTypes.number, total: PropTypes.number })
    ).isRequired,
  }).isRequired,
  domainSettings: PropTypes.exact({
    isAutomotiveIndustry: PropTypes.bool.isRequired,
    isTextingEnabled: PropTypes.bool.isRequired,
    prospectCallTypes: PropTypes.array.isRequired,
    industryType: PropTypes.string,
  }).isRequired,
  locationNames: PropTypes.array.isRequired,
  groupNames: PropTypes.array.isRequired,
};

export default ScheduledProspectReport;
